// Module
var code = "<div :class=\"['legalAgreementCheckbox t-legalAgreementCheckbox', { '-loading': isLoading, '-seen': wasSeen, '-authenticated': order.isAuthenticated && !isNewMethod }]\"> <cCheckbox :checkbox-label=\"checkboxLabel\" :is-checked=\"isChecked\" @change=\"checkTerms\"/> </div> ";
// Exports
export default code;